import React from "react";
import { Text } from "@/components/ui/text";

import Guest from "@/public/static/images/empy-state/guest.svg";
import Activities from "@/public/static/images/empy-state/activities.svg";

import Activity from "@/public/static/images/empy-state/activity.svg";
import NoDataFound from "@/public/static/images/empy-state/no-data-found.svg";
import Notification from "@/public/static/images/empy-state/notification.svg";
import NoDataReminder from "@/public/static/images/empy-state/no-data-reminder.svg";
import Community from "@/public/static/images/empy-state/community.svg";
import Search from "@/public/static/images/empy-state/search.svg";
import Tags from "@/public/static/images/empy-state/tags.svg";
import Image from "next/image";

import EventNotFound from "@/public/static/images/empy-state/myevents.svg";
type ImageKey =
  | "guest"
  | "activities"
  | "events"
  | "reminders"
  | "default"
  | "activity"
  | "tags"
  | "notification"
  | "search"
  | "community";

interface ImageMap {
  [key: string]: string;
}

const imageMap: Record<ImageKey, string> = {
  guest: Guest,
  activities: Activities,
  events: EventNotFound,
  reminders: NoDataReminder,
  default: NoDataFound,
  activity: Activity,
  tags: Tags,
  notification: Notification,
  search: Search,
  community: Community
};

interface NoDataViewProps {
  title: string;
  description?: string | JSX.Element;
  imageKey?: ImageKey;
}

const NoDataView: React.FC<NoDataViewProps> = ({
  title,
  description,
  imageKey = "default"
}: NoDataViewProps) => {
  const ImageToRender = imageMap[imageKey];

  return (
    <div className="flex flex-col items-center justify-center my-3xl">
      <Image src={ImageToRender} alt="No Data Available" className="h-[150px] w-[150px] mb-s" />
      <Text className="text-lg leading-500 font-semibold">{title}</Text>
      <Text className="text-[#707070] text-sm leading-400 ">{description}</Text>
    </div>
  );
};

export default NoDataView;
